/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EventClipDto } from '../models/event-clip-dto';
import { VisionEventModelDto } from '../models/vision-event-model-dto';
import { visionEventsControllerCreateEvent } from '../fn/vision-events/vision-events-controller-create-event';
import { VisionEventsControllerCreateEvent$Params } from '../fn/vision-events/vision-events-controller-create-event';
import { visionEventsControllerDeleteEvent } from '../fn/vision-events/vision-events-controller-delete-event';
import { VisionEventsControllerDeleteEvent$Params } from '../fn/vision-events/vision-events-controller-delete-event';
import { visionEventsControllerGetEvent } from '../fn/vision-events/vision-events-controller-get-event';
import { VisionEventsControllerGetEvent$Params } from '../fn/vision-events/vision-events-controller-get-event';
import { visionEventsControllerGetEventClip } from '../fn/vision-events/vision-events-controller-get-event-clip';
import { VisionEventsControllerGetEventClip$Params } from '../fn/vision-events/vision-events-controller-get-event-clip';
import { visionEventsControllerGetEvents } from '../fn/vision-events/vision-events-controller-get-events';
import { VisionEventsControllerGetEvents$Params } from '../fn/vision-events/vision-events-controller-get-events';
import { visionEventsControllerUpdateEvent } from '../fn/vision-events/vision-events-controller-update-event';
import { VisionEventsControllerUpdateEvent$Params } from '../fn/vision-events/vision-events-controller-update-event';

@Injectable({ providedIn: 'root' })
export class VisionEventsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visionEventsControllerGetEvents()` */
  static readonly VisionEventsControllerGetEventsPath = '/match-videos/{uuid}/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerGetEvents()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEvents$Response(params: VisionEventsControllerGetEvents$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VisionEventModelDto>>> {
    return visionEventsControllerGetEvents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerGetEvents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEvents(params: VisionEventsControllerGetEvents$Params, context?: HttpContext): Observable<Array<VisionEventModelDto>> {
    return this.visionEventsControllerGetEvents$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VisionEventModelDto>>): Array<VisionEventModelDto> => r.body)
    );
  }

  /** Path part for operation `visionEventsControllerCreateEvent()` */
  static readonly VisionEventsControllerCreateEventPath = '/match-videos/{uuid}/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerCreateEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visionEventsControllerCreateEvent$Response(params: VisionEventsControllerCreateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<VisionEventModelDto>> {
    return visionEventsControllerCreateEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerCreateEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visionEventsControllerCreateEvent(params: VisionEventsControllerCreateEvent$Params, context?: HttpContext): Observable<VisionEventModelDto> {
    return this.visionEventsControllerCreateEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<VisionEventModelDto>): VisionEventModelDto => r.body)
    );
  }

  /** Path part for operation `visionEventsControllerGetEvent()` */
  static readonly VisionEventsControllerGetEventPath = '/match-videos/{uuid}/events/{eventUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerGetEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEvent$Response(params: VisionEventsControllerGetEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<VisionEventModelDto>> {
    return visionEventsControllerGetEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerGetEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEvent(params: VisionEventsControllerGetEvent$Params, context?: HttpContext): Observable<VisionEventModelDto> {
    return this.visionEventsControllerGetEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<VisionEventModelDto>): VisionEventModelDto => r.body)
    );
  }

  /** Path part for operation `visionEventsControllerUpdateEvent()` */
  static readonly VisionEventsControllerUpdateEventPath = '/match-videos/{uuid}/events/{eventUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerUpdateEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visionEventsControllerUpdateEvent$Response(params: VisionEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<VisionEventModelDto>> {
    return visionEventsControllerUpdateEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerUpdateEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visionEventsControllerUpdateEvent(params: VisionEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<VisionEventModelDto> {
    return this.visionEventsControllerUpdateEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<VisionEventModelDto>): VisionEventModelDto => r.body)
    );
  }

  /** Path part for operation `visionEventsControllerDeleteEvent()` */
  static readonly VisionEventsControllerDeleteEventPath = '/match-videos/{uuid}/events/{eventUuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerDeleteEvent()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerDeleteEvent$Response(params: VisionEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return visionEventsControllerDeleteEvent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerDeleteEvent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerDeleteEvent(params: VisionEventsControllerDeleteEvent$Params, context?: HttpContext): Observable<void> {
    return this.visionEventsControllerDeleteEvent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `visionEventsControllerGetEventClip()` */
  static readonly VisionEventsControllerGetEventClipPath = '/match-videos/{uuid}/events/{eventUuid}/clip';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visionEventsControllerGetEventClip()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEventClip$Response(params: VisionEventsControllerGetEventClip$Params, context?: HttpContext): Observable<StrictHttpResponse<EventClipDto>> {
    return visionEventsControllerGetEventClip(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visionEventsControllerGetEventClip$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visionEventsControllerGetEventClip(params: VisionEventsControllerGetEventClip$Params, context?: HttpContext): Observable<EventClipDto> {
    return this.visionEventsControllerGetEventClip$Response(params, context).pipe(
      map((r: StrictHttpResponse<EventClipDto>): EventClipDto => r.body)
    );
  }

}
